<template>
  <label :for="name" class="flex flex-row">
    <div class="flex-none w-8">
      <input
        :id="name"
        :name="name"
        :required="required"
        type="checkbox"
        v-model="internalModel"
        :class="inputDynamicClasses"
        class="rounded border border-gray-300"
      />
    </div>

    <div class="flex-1">
      <span class="text-gray-800 font-semibold text-base"
        >{{ label }}
        <span v-if="required" class="text-red-800 font-bold"
          >* <span class="sr-only">Required Field</span></span
        ></span
      >
      <span
        class="text-gray-800 text-sm font-light block"
        v-html="description"
      ></span>
      <span v-if="vuelidation.$dirty && vuelidation.$invalid" class="block">
        <span class="text-red-900 italic" v-if="vuelidation.required === false"
          >Required field</span
        >
        <span class="text-red-900 italic" v-if="vuelidation.email === false"
          >Please enter a valid email address.</span
        >
        <!-- @TODO: Code Smell. Shouldn't be baked into component like this. -->
        <span
          class="text-red-900 italic"
          v-if="vuelidation.sameAsPhone === false"
          >Please ensure you entered your phone number correctly.</span
        >
        <span class="text-red-900 italic" v-if="vuelidation.maxLength === false"
          >Please use a state shortcode (TN, CA) instead of a longer name.</span
        >
      </span>
    </div>
  </label>
</template>

<script>
// @TODO: Update to Vue3.
export default {
  model: {
    prop: "value",
  },
  props: {
    name: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Boolean],
      default: false,
    },
    description: {
      type: String,
      default: "",
    },
    required: Boolean,
    vuelidation: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  computed: {
    inputDynamicClasses() {
      const error = this.vuelidation.$dirty && this.vuelidation.$invalid;
      return {
        "border-red-600": error,
        "border-gray-300": !error,
      };
    },
    internalModel: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  emits: ["update:modelValue"],
  methods: {
    // eslint-disable-next-line
    inputMethod: function ($event) {
      if (this.vuelidation.$touch) {
        this.vuelidation.$touch();
      }

      this.internalModel = $event.target.value;
    },
  },
};
</script>
